// 会员管理模块 API
import axios from '@/api/axios.js'

// 获取会员列表
export function exportList(limit, page,) { return axios.get(`/consumer/list_data?limit=${limit}&page=${page}`) }

// 游玩记录
export function palyRecordData(limit, page, uid) {
    return axios.post(`/consumer/play_record?limit=${limit}&page=${page}&uid=${uid}`)
}

// 查询
export function queryMembersData(limit, page, phone, uid) {
    return axios.get(`/consumer/list_data?limit=${limit}&page=${page}&phone=${phone}&uid=${uid}`)
}

// 查询
export function getMembersSearch(data) { return axios.post('/getMembersSearch', data) }

// 会员列表
export function getConsumerList(data) { return axios.get('consumer/list_data', { params: data }) }









// WEBPACK FOOTER //
// ./src/api/Members.js